import {
    getAdminSettingsPageData,
    getCustomersPageData,
    getDesignSettingsDetailsHref,
    getPriceSetupsPageData,
    getProductPoliciesPageData,
    getQualityCheckPageData,
    getReturnReasonSetupsHref,
    getReturnReasonsPageData,
    getReturnsPageData,
    getShipmentIntegrationsPageData,
    getTextOverridesPageData,
    getUserSettingsPageData,
    getWarehouseIncomingItemsPageData,
} from "./cores/pageAccessCore";
import { APP_DESIGN_SETTING_CATEGORY } from "./app/(pages)/settings/app-design/AppDesignForm";

export const newFeatures = [
    {
        date: "2026-03-09",
        title: "Return Reason Setups",
        description:
            "Return and complaint reasons are replaced with Return Reason Setups. What this means is:\n\n• Complaint reasons can now also have different configurations based on product type.\n• The UX have been harmonized to give a better overview of selected setups, similar to Price Setups.\n• It is now technically much simpler to extend future functionality, for example adding additional pre-conditions.",
        imageUrl: "/newFeatures/returnReasonSetups.png",
        link: getReturnReasonsPageData().href,
    },
    {
        date: "2026-02-24",
        title: "Complaint reason updated",
        description: "• Complaint reasons now have sub reasons and external codes similar to return reasons.\n• Future work to harmonize return reasons and complaint reasons is still ongoing.",
        link: getReturnReasonSetupsHref(),
    },
    {
        date: "2025-11-10",
        title: "Text override updates",
        description: "• Preview of how the original & new text are rendered in the app\n• Copy the original text (in any language)\n• Dynamic expanding of input text fields",
        link: getTextOverridesPageData().href,
    },
    {
        date: "2025-11-05",
        title: "Some pages have been moved",
        description: "Users and API-keys pages have moved.\n\n• Users is in Settings -> Admin. \n• API-keys is in Integrations",
    },
    {
        date: "2025-08-27",
        title: "Text override updates",
        description: "Text override now offers a special key language key called English auto-translation. This can be used to improve ambiguous auto-translations",
        link: getTextOverridesPageData().href,
    },
    {
        date: "2025-06-25",
        title: "User permission updates",
        description:
            "• As an admin you can now delete/handle other users more freely.\n• In price setups. You can now delete shop addresses. We have also added some extra functionality like cloning shop addresses",
        link: getPriceSetupsPageData().href,
    },
    {
        date: "2025-06-09",
        title: "Complaint reports",
        description: "We have added 4 new complaint values when generating reports. See image",
        imageUrl: "/newFeatures/complaintReports.png",
    },
    {
        date: "2025-06-09",
        title: "Block customers",
        description: "You can now block customers for any reason from using the return application.\nYou can also choose to only block early compensations such as refunds, giftcards and exchanges.",
        imageUrl: "/newFeatures/blockCustomer.png",
        link: getCustomersPageData().href,
    },
    {
        date: "2025-06-09",
        title: "UPS shipment service priority",
        description:
            "When setting up the carrier UPS in Price Setup you can now select which exact shipping service should be used.\n You can also control what order an attempt to book a shipment should be used in-case one service is not available at that address.",
        imageUrl: "/newFeatures/upsShipmentService.png",
        link: getPriceSetupsPageData().href,
    },
    {
        date: "2025-05-23",
        title: "Custom Text Overrides for Admins",
        description:
            "The ability to customize texts have been opened up for all admins.\n\n• Override default english texts in the return portal\n• Override translations for any text and any enabled language",
        link: getAdminSettingsPageData().href,
    },
    {
        date: "2025-05-22",
        title: "Added change log",
        description:
            "For improved transparency, we have added this change log feature. This is a list of new features and improvements we continuously add to the platform. We hope you find it helpful!",
    },
    {
        date: "2025-05-22",
        title: "Shipment Integrations Improvements",
        description: "The Shipment Integrations page has been upgraded with:\n\n• New user interface\n• Added support for new Helthjem API",
        link: getShipmentIntegrationsPageData().href,
    },
    {
        date: "2025-05-19",
        title: "Exchange Improvements in the Return App",
        description:
            "When exchanging items we have added the following features:\n\n• Product comparison button to compare previous item with new item\n• Improved UX for the various exchange property pickers\n• New app design setting to force only dropdowns for properties",
        link: getDesignSettingsDetailsHref({ detailsId: APP_DESIGN_SETTING_CATEGORY.OTHER.id }),
    },
    {
        date: "2025-05-15",
        title: "Warehouse Reports Enhancement",
        description:
            "Added 'Reviewed By' functionality to warehouse reports with benefits:\n\n• Better tracking of report reviewers\n• Improved accountability in the warehouse\n• Added option to disable reviews in Quality Check",
        link: getWarehouseIncomingItemsPageData().href,
    },
    {
        date: "2025-05-14",
        title: "Complaint Management Improvements",
        description: "Added the ability to add comments to approved complaints. These comments can also be used for complaint approved emails.",
    },
    {
        date: "2025-05-08",
        title: "Return Station Improvements",
        description: "• Added the ability to configure return stations in shop settings\n• A user can now be limited to specific return stations",
        link: getUserSettingsPageData().href,
    },
    {
        date: "2025-05-02",
        title: "Quality Check 2.0 with Barcode Scanning",
        description:
            "Quality check got a complete rework:\n\n• Support for scanning shipment label\n• Support for scanning product barcodes\n• Streamlined submission process\n• Automatic creation of new returns or adding items to existing returns\n• Ability to add custom items for correctness\n• Several UX updates",
        link: getQualityCheckPageData().href,
    },
    {
        date: "2025-04-23",
        title: "Product Policy Creation",
        description: "Added a new action button for creating product policies based on order/line-item tags.",
        link: getProductPoliciesPageData().href,
    },
    {
        date: "2025-04-09",
        title: "Search Highlighting in Tables",
        description: "Added search highlighting functionality in returns and various tables, making it easier to identify relevant information at a glance.",
        link: getReturnsPageData().href,
    },
    {
        date: "2025-03-05",
        title: "Multiple product images in Return App",
        description: "• Added support for multiple images in the return app.\n• Support for custom image aspect ratios",
        link: getDesignSettingsDetailsHref({ detailsId: APP_DESIGN_SETTING_CATEGORY.OTHER.id }),
    },
];
